import { PrepopulatedCredentials } from '@citrite/workspace-ui-platform';
import $ from 'jquery';

export const FormActions = {
	populateForm(form: JQuery, prePopulatedCredentials: PrepopulatedCredentials) {
		if (prePopulatedCredentials == null || $.isEmptyObject(prePopulatedCredentials)) {
			return;
		}

		const credentials = [];
		credentials.push({
			id: 'username',
			value:
				(prePopulatedCredentials.domain && prePopulatedCredentials.domain.length > 0
					? prePopulatedCredentials.domain + '\\'
					: '') + prePopulatedCredentials.username,
		});
		credentials.push({ id: 'password', value: prePopulatedCredentials.password });

		$.each(credentials, function (_index, credential) {
			const id = credential.id;
			const value = credential.value;

			const idSelector = '#' + id;
			$(idSelector + ':text', form)
				.addClass('prePopulatedCredential')
				.val(value);
			$(idSelector + ':password', form)
				.addClass('prePopulatedCredential')
				.val(value);
			$(idSelector + ':checkbox', form)
				.addClass('prePopulatedCredential')
				.each(function (this: HTMLElement) {
					const checkbox = $(this);
					if (value === 'true' || value === 'True') {
						checkbox.attr('checked', 'checked');
					} else {
						checkbox.attr('checked', false as any);
					}
				});
		});
	},

	disableFormAndShowHourglass($form: JQuery, buttonDetails: { id: string }) {
		$('body').css('cursor', 'wait');
		$form.find('input').prop('disabled', true);

		// Protect against syntax error in the event of an empty id
		const $clickedButton =
			buttonDetails && buttonDetails.id ? $form.find('#' + buttonDetails.id) : $();

		// Assume that anything that looks like a button (apart from what the user clicked) should be disabled
		$form.find('.button').not($clickedButton).addClass('disabled');

		// The clicked button displays a spinner in place of the text
		$clickedButton
			.width($clickedButton.width()) // Ensure that the button size does not change when the text is removed
			.text('')
			.addClass('waiting');
	},
	resetDSAuthStyling() {
		$('body').css('cursor', 'default');
	},
};
